export class ImageModel {
    URL: string;
    IsSelected: boolean = true;
    IsLogosImage: boolean = true;
    IsOtherImage: boolean = true;
}
